export default __webpack_public_path__ + "static/media/location.d408d7b3.svg";